import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";

interface UsePartnerTimelineProps {
	partnershipId: string;
	currentWeek: string;
}

export function usePartnerTimeline({ partnershipId, currentWeek }: UsePartnerTimelineProps) {
	const { organization } = useAuth();

	/** Hooks */
	const query = useQuery({
		queryKey: ["partner", "timeline", partnershipId, currentWeek],
		queryFn: async () => {
			if (!organization) throw new Error("Organization not found");
			const response = await client.organizations[":orgId"].partnerships[
				":partnershipId"
			].timeline.$get({
				param: {
					orgId: guardString(organization.id),
					partnershipId,
				},
				query: {
					week: currentWeek,
				},
			});
			const data = await responseHandler(response);
			return data;
		},
		staleTime: 5000,
	});

	return query;
}
